import { i18n, Row, Form, Cell, http } from "@common";
import { useCallback, useRef, useState, useImperativeHandle, forwardRef, useEffect } from "react";
import { StaffScheduleIntervalI18N, StaffScheduleIntervalOptions } from "../../../constant";
import { adminService } from "@api";

const Schedule = (props) => {
    const { status, reloadTable } = props;
    const pageRef = useRef();

    const button = [
        {
            text: i18n.get("Common_Cancel_Entry"),
            name: "cancel",
            onClick: () => pageRef.current.onPanelButtonClick("cancel"),
        },
        {
            text: i18n.get("Common_Save_Entry"),
            classify: "info",
            name: "save",
            onClick: () => pageRef.current.onPanelButtonClick('save'),
        }];

    return (
        <R.Panel
            id="panel-staff-access-review-schedule"
            title={i18n.get("CIS_Admin_Reporting_StaffAccessReview_Schedule_Title_Entry")}
            status={status}
            buttons={button}
            willClose={() => pageRef.current.onPanelButtonClick('cancel')}
        >
            <Content ref={pageRef} reloadTable={reloadTable} />
        </R.Panel>
    );
};

const Content = forwardRef((props, refs) => {
    const [formItem, setFormItem] = useState({
        interval: null,
        startDate: null,
        endDate: null,
    });
    const formRef = useRef();
    const dateRef = useRef();

    const { reloadTable } = props;

    const timeFormat = (strTime) => {
        return typeof strTime === 'string' ? new Date(strTime) : strTime;
    };

    useEffect(() => {
        $$.loading(true);
        adminService.staffAcessFindSchedulerRules().then((res) => {
            const data = res?.items;
            setFormItem({
                interval: data?.interval,
                startDate: timeFormat(data?.startDate),
                endDate: timeFormat(data?.endDate)
            });
        }).finally(() => {
            $$.loading(false);
        });
    }, []);

    const onSave = useCallback(() => {
        if (!formRef.current.validate()) {
            return false;
        }
        const timeZone = new Date().getTimezoneOffset() / -60;
        let param = {
            Interval: formItem.interval,
            StartDate: formItem.startDate,
            EndDate: formItem.endDate,
            timeZone
        };
        $$.loading(true);
        return adminService.staffAcessUpdateScheduler(param).then(() => {
            reloadTable(false, i18n.get('CIS_Admin_Reporting_StaffAccessReview_ScheduleSuccess_Message'), true);
        }).catch(e => {
            $$.loading(false);
            if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.toast(e?.message, 'warning');
            } else {
                $$.toast(i18n.get('CIS_Admin_Reporting_StaffAccessReview_ScheduleFaild_Message'), 'error');
            }
            throw e;
        }).finally(() => {
            $$.loading(false);
        });
    }, [formItem.endDate, formItem.interval, formItem.startDate, reloadTable]);

    const willClose = useCallback(() => {
        return formRef.current.areyousure.check();
    }, []);

    useImperativeHandle(refs, () => ({
        onPanelButtonClick: name => {
            switch (name) {
                case 'save':
                    return onSave();
                case 'cancel':
                    return willClose();
                default:
                    return false;
            }
        }
    }), [onSave, willClose]);

    const validateEffectDate = () => {
        let startDate = formRef.current.startDate, endDate = formRef.current.endDate;
        if (startDate && endDate && new Date(startDate).getTime() > new Date(endDate).getTime()) {
            return i18n.get('Common_Filter_Date_Validate_Message');
        }
        return true;
    };

    const handleFromChange = (key, value) => {
        setFormItem(item => ({ ...item, [key]: value }));
        if (key === 'startDate') {
            formRef.current.startDate = value;
        } else if (key === 'endDate') {
            formRef.current.endDate = value;
        }
    };

    return (
        <Form ref={formRef}>
            <Row>
                <Cell label={i18n.get('CIS_Admin_Reporting_StaffAccessReview_Schedule_Interval_Entry')} required validation="Combobox">
                    <R.Combobox
                        id="combobox-StaffAccessReview-Schedule-Interval"
                        items={StaffScheduleIntervalOptions}
                        value={StaffScheduleIntervalI18N[formItem.interval]}
                        width="100%"
                        onChange={value => { handleFromChange('interval', value.newValue.value); }}
                        attrs={{ 'aria-labelledby': Form.formlabel }}
                        searchable={false}
                    />
                </Cell>
            </Row>
            <Row>
                <Cell
                    label={i18n.get('CIS_Admin_Reporting_StaffAccessReview_Schedule_StartDate_Entry')} required validation='Datepicker'>
                    <R.Datepicker
                        id="datepicker-staffAccessReview-Schedule-StartDate"
                        selectedDate={formItem.startDate}
                        onChange={value => { handleFromChange('startDate', value.newValue); dateRef.current.validate(); }}
                        clearable={true}
                        attrs={{ 'aria-labelledby': Form.formlabel }}
                    />
                </Cell>
            </Row>
            <Row>
                <Cell
                    label={i18n.get('CIS_Admin_Reporting_StaffAccessReview_Schedule_EndDate_Entry')}
                    validation={{ type: 'Datepicker', valFunction: validateEffectDate }}
                    ref={dateRef}
                >
                    <R.Datepicker
                        id="datepicker-staffAccessReview-Schedule-endDate"
                        selectedDate={formItem.endDate}
                        onChange={value => { handleFromChange('endDate', value.newValue); }}
                        clearable={"force"}
                        attrs={{ 'aria-labelledby': Form.formlabel }}
                        enableDates={{ start: new Date(formItem.startDate) }}
                    />
                </Cell>
            </Row>
        </Form >
    );
});

export default Schedule;